import React from 'react';
import { Icon, TooltipContainer, TooltipContent, TooltipTriangle } from './MyBetsTooltip.style';
import { observer } from 'src/utils/mobx-react';
import { MyBetsTooltipState } from './MyBetsTooltip.state';

type TooltipPropsType = {
    content: React.ReactNode;
};

export const MyBetsTooltip = observer('MyBetsTooltip', (props: TooltipPropsType) => {
    const [state] = React.useState(() => new MyBetsTooltipState());

    return (
        <TooltipContainer
            onClick={state.handleClick}
            onBlur={state.handleBlur}
        >
            <Icon />
            <TooltipTriangle isActive={state.isActive} />
            <TooltipContent isActive={state.isActive}>{props.content}</TooltipContent>
        </TooltipContainer>
    );
});
